export default __webpack_public_path__ + "static/media/DECDOM2025.ab18def2.png";